<template>
  <grid-container class="search" :cols="`minmax(140px, auto) 48px`">
    <v-text-field
      v-model="q"
      @keyup.enter="search"
      class="rounded-0 grey lighten-4 text-body-2"
      color="grey darken-2"
      background-color="white"
      label="Buscar"
      type="search"
      hide-details
      solo
      flat
      outlined
      clearable
      clear-icon="fas fa-times"
    ></v-text-field>
    <v-btn
      @click="search"
      :color="color"
      height="50px"
      width="50px"
      min-width="50px"
      tile
      depressed
    >
      <v-icon small>fas fa-search </v-icon>
    </v-btn>
  </grid-container>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary",
    },
  },
  data: () => ({
    q: "",
  }),
  methods: {
    search() {
      if (this.q) {
        this.$router.push(`/noticias?q=${this.q}`);
        this.$emit("search");
      }
    },
  },
};
</script>

<style>
</style>
